import React from 'react'
import { Create, TextInput, NumberInput, useTranslate, SimpleForm, required, BooleanInput } from 'react-admin'
import { CardCommon } from 'src/components/uiElements'
import { Grid } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'

export const FormulaGlobalVariablesCreate = (props) => {
  const translate = useTranslate()
  return (
    <Create {...props} redirect='list' actions={null}>
      <CardCommon title={translate('ra.entity.formula-global-variables')} actions={null}>
        <SimpleForm>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.name')} required>
              <TextInput source='name' validate={required()} label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.value')}>
              <NumberInput label='' source='value' fullWidth />{' '}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.show_breakdown')}>
              <BooleanInput label={translate('ra.field.show_breakdown')} source='show' fullWidth />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
